import { forwardRef, type Ref, type SVGProps } from "react";

function SvgError(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={177}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#error_svg__a)">
        <circle cx={88.111} cy={60} r={50} stroke="url(#error_svg__b)" strokeWidth={20} />
        <path
          stroke="#0C1C43"
          strokeLinecap="round"
          d="m78.582 52.47 19.059 19.06m0-19.06L78.582 71.53"
        />
      </g>
      <rect width={39} height={39} x={34.111} y={7.5} fill="#B01921" rx={19.5} />
      <rect width={39} height={39} x={34.111} y={7.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M53.611 21v7m0 3v1"
      />
      <defs>
        <linearGradient
          id="error_svg__b"
          x1={88.111}
          x2={87.681}
          y1={10}
          y2={85.533}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#F9E1E1" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="error_svg__a">
          <rect width={100} height={100} x={38.111} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgError);
export default ForwardRef;
